<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q2T0Bg/tc-custom/9781429972116.jpg?1725937972528" alt="This image is the cover for the book Heavy Planet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heavy Planet
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From “a tremendous force in science fiction,” a collection set on the high-gravity planet of Mesklin, and an essay by the author on Mesklin’s creation (</b><b>Poul Anderson, Hugo and Nebula award-winning author of <i>The Broken Sword</i>).</b><br/><br/> Discover MESKLIN—Gravity: 3g at the equator, 700g at the poles<br/><br/> Hal Clement is a Grand Master of SF, and the one most associated with the subgenre of hard SF. From his classic stories in <i>Astounding</i> magazine in the 1940s through his novels of the 1950s and on to the recent <i>Half Life</i>, he has made a lasting impression on SF readers, and on writers, too. For many of them, Clement's work is the model of how to write hard SF, and this book contains the reasons why. <br/>  <br/> Here are all the tales of bizarre, unforgettable Mesklin: the classic novel <i>Mission of Gravity</i> and its sequel, <i>Star Light</i>, as well as the short stories “Under” and “Lecture Demonstration.” Also included is “Whirligig World,” the famous essay Clement published in <i>Astounding</i> in 1953. It describes the rigorous process he used to create his intriguingly plausible high-gravity planet, with its odd flattened shape, its day less than eighteen minutes long, and its many-limbed, noble natives. Come to Mesklin and learn why <i>The Encyclopedia of Science Fiction</i> called <i>Mission of Gravity</i> ”one of the best loved novels in SF.”<br/><br/> At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.<br/>  <br/> “Hal Clement...has been writing for the last half century. In that time he has defined the ‘hard SF’ subgenre and established it as his own.” —<i>Analog</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hal Clement
      </h2>
      
      <p class="authorDescription body article"><B>Hal Clement </B>(1922-2003) is a Science Fiction Writers of America Grand Master, and the author of the novels <I>Half Life, Heavy Planet</I> and the classic <I>Mission of Gravity</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44e28a4a